import { tv } from '@change/ds-utils';

export const BodyStyles = tv({
	base: 'bg-background-base flex flex-col',
	variants: {
		size: {
			small: 'w-full gap-1',
			medium: 'w-full gap-2.5',
			large: 'w-full gap-3',
		},
	},
});

export const BodyTextStyles = tv({
	base: 'tracking-0 whitespace-pre-wrap font-[Arial] leading-[140%]',
	variants: {
		size: {
			small: 'max-h[118px] px-[5px] text-[5px]',
			medium: 'max-h[237px] px-2.5 text-[10px]',
			large: 'max-h[289px] px-3 text-[12px]',
		},
	},
});

export const BodyImageStyles = tv({
	base: 'object-fill',
	variants: {
		size: {
			small: 'h-[53px] w-full',
			medium: 'h-[105px] w-full',
			large: 'h-[123px] w-full',
		},
	},
});
